<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="[permissionService.Permission.location_create]"
    sb-button-primary
    type="button"
    color="green"
    icon="plus"
    [disabled]="loading()"
    [iconButton]="true"
    sbTooltip="{{ 'lang.locations.createLocation' | translate }}" container="body"
    [queryParams]="{managedBy: getManagerId(), returnTo: util.getPageLink()}"
    [sbRouterLink]="util.RoutingID.locationCreate">
  </button>
  <button
    type="button"
    sb-button-primary
    icon="refresh"
    [iconButton]="true"
    [color]="'blue'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" container="body"
    placement="top">
  </button>
  <button
    *ngPermissions="permissionService.Permission.location_export"
    sb-button-primary
    type="button"
    [color]="'blue'"
    [icon]="'download'"
    [disabled]="loading()"
    [sbTooltip]="'lang.globals.exportAll' | translate"
    (click)="showSideBar= true; isSelectedLocationsExport = false;"
    [iconButton]="true"
  ></button>
  <button
    sb-button-primary
    type="button"
    [color]="'blue'"
    [disabled]="loading()"
    [sbTooltip]="'lang.globals.columnOptions' | translate"
    (click)="openColumnOptionModal(applyColumns.bind(this))"
    [iconButton]="true"
    [icon]="'columns'"
  >
  </button>
</ng-container>


<!------------------------------

      Settings Modal

------------------------------->
<ng-template [sbmodal]="'devlistdevsettingsmodal'">
  <sb-custom-modal [templateId]="'devlistdevsettingsmodal'">
    <sb-comp-settings [modal]="'devlistdevsettingsmodal'" slot="body">
    </sb-comp-settings>
  </sb-custom-modal>
</ng-template>

<ng-template [sbmodal]="'deleteWarning'">
  <sb-custom-modal [templateId]="'deleteWarning'">
    <div slot="body">
      {{ "lang.globals.deleteDevicesAtLocationInfo" | translate }}
    </div>
  </sb-custom-modal>
</ng-template>


<!------------------------------

    Side Panel

------------------------------->

<sb-comp-side-panel
  (showChange)="showSideBar = $event" [show]="showSideBar"
  [sidebarHeader]="sidePanelHeaderExport"
  [sidebarTemplate]="sidePanelTemplateExport"
  [sidebarFooter]="sidePanelFooterExport"
  [width]="600">

</sb-comp-side-panel>

<ng-template #sidePanelHeaderExport>
  <h4>{{ 'lang.globals.createLocationsReport' | translate }}</h4>
</ng-template>

<ng-template #sidePanelTemplateExport>
  <form [formGroup]="form" class="">
    <div class="form-group validateMe">
      <label class="form-label" for="Title">{{ 'lang.globals.title' | translate }}</label>
      <input type="text" id="Title" class="form-control" formControlName="Title"
             sbAutofocus>
    </div>
  </form>
</ng-template>

<ng-template #sidePanelFooterExport>
  <div class="tw-flex tw-justify-between">
    <button
      sb-button-secondary
      type="button"
      [color]="'red'"
      [icon]="'cancel'"
      (click)="showSideBar = false; form.reset()"
    >{{ 'lang.globals.cancel' | translate }}
    </button>
    <button
      sb-button-secondary
      type="button"
      [color]="'blue'"
      [icon]="'save'"
      [disabled]="form.invalid"
      (click)="export()"
    >{{ 'lang.globals.save' | translate }}
    </button>
  </div>
</ng-template>
<!------------------------------

      table wrapper

------------------------------->

@let isExpanded = checkExpansion();
<sb-table-wrapper-new
  (paginationChange)="requestDebounced($event)"
  [isInModalContext]="selectionMode"
  [itemName]="'locations'"
  [itemsData]="locations()"
  [loading]="loading()"
  [isFilterPanelOpen]="isExpanded"
  class="tw-w-full"
  [isMultiSelectEnabled]="selectedLocations()?.size > 0"
  headline="{{'lang.headlines.locations' | translate}}">
  <!------------------------------

   Filter

------------------------------->
  <div filter-panel class="dark:tw-bg-sbGray-930 tw-bg-[#F8F9FC] tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >
      <sb-filter-section
        [alwaysExpanded]="true"
        title="{{'lang.globals.statusFilter' |translate}}" icon="toggleOn"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-toggle filterID="online" [default]="true" [label]="'lang.globals.online' | translate"></sb-filter-toggle>
        <sb-filter-toggle filterID="mixed" [default]="true"
                          [label]="'lang.globals.mixed' | translate"></sb-filter-toggle>
        <sb-filter-toggle filterID="offline" [default]="true" [label]="'lang.globals.offline' | translate"></sb-filter-toggle>
        <sb-filter-toggle filterID="unknown" [default]="true" [label]="'lang.globals.unknown' | translate"></sb-filter-toggle>
      </sb-filter-section>
      <sb-filter-section
        title="{{'lang.globals.filterAttributes' |translate}}" icon="wrench"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-threeway-toggle filterID="hasDevices" [default]="null"
                                   [label]="'lang.attributeToggles.location.hasDevices' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="hasManager" [default]="null"
                                   [label]="'lang.attributeToggles.location.hasManager' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="hasPoint" [default]="null"
                                   [label]="'lang.attributeToggles.location.hasPointLocation' | translate"></sb-filter-threeway-toggle>
      </sb-filter-section>
      <sb-filter-section *ngPermissions="permissionService.Permission.cull_list" title="{{'lang.globals.playerCull' | translate}}"
                         icon="playerOnline">
        <sb-filter-dto-list-select filterID="playerCulls" [endpoint]="api.cs_Cull_retrieveAll.bind(api)"
                                   [endpointOptions]="{type: 'PlayerCull'}">
        </sb-filter-dto-list-select>
      </sb-filter-section>
      <sb-filter-section *ngPermissions="permissionService.Permission.company_list" title="{{'lang.globals.companies' | translate}}"
                         icon="company">
        <sb-filter-dto-list-select filterID="managedBy" [endpoint]="api.shared_Company_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>
      <sb-filter-section *ngPermissions="permissionService.Permission.weekly_schedule_list"
                         title="{{'lang.globals.weeklySchedules' | translate}}"
                         icon="clock">
        <sb-filter-dto-list-select filterID="schedules" [endpoint]="api.ca_md_WeeklySchedule_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>

      <div class="tw-mx-3 tw-gap-2.5 tw-flex tw-flex-col">
        <div
          #filterPanelOrder
          class="tw-flex tw-flex-row tw-font-semibold tw-items-center tw-duration-500 tw-transition-all tw-ease-in-out tw-group tw-w-fit"
          [ngClass]="{'tw-cursor-pointer': !isExpanded}"
          (click)="!isExpanded?openFilterPanel(filterPanelOrder):scrollToFilterPanelElement(filterPanelOrder)">
          <sb-icon class="tw-text-xl tw-transition-all tw-duration-500" [ngClass]="{'tw-ml-2.5': !isExpanded}"
                   icon="sort"></sb-icon>
          <div class="tw-duration-500 tw-transition-all tw-ease-in-out tw-origin-left tw-text-lg tw-flex-1"
               [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-full tw-ml-2.5': isExpanded,
    }">{{ 'lang.globals.order' | translate }}
          </div>
        </div>
        <div class="tw-flex tw-gap-2.5">

          @let fpOrderOption = filterPanelOrderOption();
          <sb-button-dropdown
            [selectedValue]="fpOrderOption.value" [items]="allOrderOptions|omit: 'direction'"
            (outputChange)="setToOrderFilterPanel(filterPanelOrderOption, $event)"
            [openDirection]="'Up'"
            class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-origin-left"
            [ngClass]="{
            'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
            'tw-opacity-100 tw-flex': isExpanded,
          }"
          >
          </sb-button-dropdown>
          <sb-segment-control
            [ngClass]="{
            'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
            'tw-opacity-100 tw-flex': isExpanded,
          }"
            [selectedOption]="{value: fpOrderOption.direction}"
            [options]="[{value: 'asc', icon: 'sortUpFilled' },{value: 'desc', icon: 'sortDownFilled' }]"
            (selectedOptionChange)="setOrderDirectionFilterPanel(filterPanelOrderOption, $event.value)"
          ></sb-segment-control>
        </div>
      </div>
    </sb-filter-panel>
  </div>

  <!------------------------------

      Table Header

------------------------------->
  <ng-template #thead>
    @let currentOrderOption = orderOption();
    <tr #tableHead (cdkDropListDropped)="dropListDropped($event, applyColumns.bind(this))" cdkDropList cdkDropListOrientation="horizontal"
        class="noselect">
      @if (!selectionMode) {
        <th class="sticky-col first-col">
          <sb-comp-table-multi-select-button [selectionState]="selectionState()"
                                             (action)="selectAction($event)"></sb-comp-table-multi-select-button>
        </th>
      }
      <th>
        {{ 'lang.globals.status' | translate }}
      </th>
      <th>
        {{ 'lang.globals.devices' | translate }}
      </th>
      <th *ngPermissions="[permissionService.Permission.tag_list]">
        Tags
      </th>
      @for (column of selectedColumns; track column.id; let i = $index) {
        <th (cdkDragStarted)="dragStarted($event, i)" [cdkDragData]="column" [cdkDragDisabled]="window.scrollY > 0"
            cdkDrag class="stickyHeaderViewChild" nowrap>
          <div class="tw-flex tw-items-center tw-gap-2">
            @let isColSortingAllowed = isSortingAllowed(column);
            @let isColFilteringAllowed = isFilteringAllowed(column);
            @if (isColSortingAllowed) {
              <div (click)="setToOrderAndRefresh(column)" class="cursor-pointer d-inline-flex *:tw-ml-2 hover:tw-text-sbBlue-500"
                   [ngClass]="{'tw-text-sbBlue-500': currentOrderOption?.value?.id===column?.id}">
                {{ (column.title ?? column.id) |translate }}
                @if (currentOrderOption.value?.id === column?.id) {
                  @if (currentOrderOption.direction === 'desc') {
                    <sb-icon icon="sortDownFilled"></sb-icon>
                  } @else {
                    <sb-icon icon="sortUpFilled"></sb-icon>
                  }
                } @else {
                  <sb-icon icon="sort"></sb-icon>
                }
              </div>
            } @else {
              <div class="">
                {{ (column.title ?? column.id) |translate }}
              </div>
            }
            @if (isColSortingAllowed && isColFilteringAllowed) {
              <div class="vertical-spacer"></div>
            }
            @if (isColFilteringAllowed) {
              <div
                (click)="columnFilter(column, 'locationFilter')"
                [ngClass]="{'tw-text-sbBlue-500': isFilterClassActive(column), 'tw-animate-ping-bg': !loading() && columnFiltersMap.has(column.id)}"
                class="cursor-pointer tw-flex tw-items-center hover:tw-text-sbBlue-500">
                @if (isFilterClassActive(column)) {
                  <sb-icon [icon]="'funnelFilled'"></sb-icon>
                } @else {
                  <sb-icon [icon]="'funnel'"></sb-icon>

                }
              </div>
              @if (column.type !== 'PROPERTY') {
                <div class="vertical-spacer"></div>
                <sb-icon [icon]="getColumnIcon(column)" [ngbTooltip]="getColumnTypeTitle(column)"
                         class="cursor-help" container="body">
                </sb-icon>
              }
            }
          </div>
          <div *cdkDragPreview class="drag-placeholder dark:tw-text-white">
            {{ (column.title ?? column.id) |translate }}
          </div>
        </th>
      }
      <th class="sticky-col last-col tw-z-20">
        {{ 'lang.globals.action' |translate }}
      </th>
    </tr>
  </ng-template>

  <!------------------------------

      Card Table Header

------------------------------->
  <ng-template #tCardHead>
    @let currentOrderOption = orderOption();
    <tr #tableHead (cdkDropListDropped)="dropListDropped($event, applyColumns.bind(this))" cdkDropList cdkDropListOrientation="horizontal"
        class="noselect">
      @if (!selectionMode) {
        <th>
          <sb-comp-table-multi-select-button [selectionState]="selectionState()"
                                             (action)="selectAction($event)"></sb-comp-table-multi-select-button>
        </th>
      }
      <th>
        {{ 'lang.globals.status' | translate }}
      </th>
      <th>
        {{ 'lang.globals.devices' | translate }}
      </th>
      <th *ngPermissions="[permissionService.Permission.tag_list]">
        Tags
      </th>
      @for (column of selectedColumns; track column.id; let i = $index) {
        @let isColSortingAllowed = isSortingAllowed(column);
        @let isColFilteringAllowed = isFilteringAllowed(column);
        @if (isColSortingAllowed || isColFilteringAllowed) {
          <th (cdkDragStarted)="dragStarted($event, i)" [cdkDragData]="column" [cdkDragDisabled]="window.scrollY > 0"
              cdkDrag class="stickyHeaderViewChild" nowrap>
            <div class="tw-flex tw-items-center tw-gap-2">
              @if (isColSortingAllowed) {
                <div (click)="setToOrderAndRefresh(column)" class="cursor-pointer d-inline-flex *:tw-ml-2 hover:tw-text-sbBlue-500"
                     [ngClass]="{'tw-text-sbBlue-500': currentOrderOption?.value?.id===column?.id}">
                  {{ (column.title ?? column.id) |translate }}
                  @if (currentOrderOption.value?.id === column?.id) {
                    @if (currentOrderOption.direction === 'desc') {
                      <sb-icon icon="sortDownFilled"></sb-icon>
                    } @else {
                      <sb-icon icon="sortUpFilled"></sb-icon>
                    }
                  } @else {
                    <sb-icon icon="sort"></sb-icon>
                  }
                </div>
              } @else {
                <div class="">
                  {{ (column.title ?? column.id) |translate }}
                </div>
              }
              @if (isColSortingAllowed && isColFilteringAllowed) {
                <div class="vertical-spacer"></div>
              }
              @if (isColFilteringAllowed) {
                <div
                  (click)="columnFilter(column, 'locationFilter')"
                  [ngClass]="{'tw-text-sbBlue-500': isFilterClassActive(column), 'tw-animate-ping-bg': !loading() && columnFiltersMap.has(column.id)}"
                  class="cursor-pointer tw-flex tw-items-center hover:tw-text-sbBlue-500">
                  @if (isFilterClassActive(column)) {
                    <sb-icon [icon]="'funnelFilled'"></sb-icon>
                  } @else {
                    <sb-icon [icon]="'funnel'"></sb-icon>

                  }
                </div>
                @if (column.type !== 'PROPERTY') {
                  <div class="vertical-spacer"></div>
                  <sb-icon [icon]="getColumnIcon(column)" [ngbTooltip]="getColumnTypeTitle(column)"
                           class="cursor-help" container="body">
                  </sb-icon>
                }
              }
            </div>
            <div *cdkDragPreview class="drag-placeholder dark:tw-text-white">
              {{ (column.title ?? column.id) |translate }}
            </div>
          </th>
        }
      }
      <th class="!tw-w-auto"><!-- empty header for minimal header with on the others --></th>
    </tr>
  </ng-template>
  <!------------------------------

   SelectionMode

------------------------------->
  <ng-template #tSelectionMode>
    <sb-action-bar [isInModalContext]="isInModalContext">
      <!-- projected info -->
      <div info>
        {{ selectedLocations().size }} {{ 'lang.globals.selected' | translate }}
      </div>

      <!-- deselect button -->
      <button
        deselect
        type="button"
        sb-button-secondary
        [color]="'blue'"
        class="tw-text-nowrap"
        (click)="selectAction('deselectAll')">
        {{ 'lang.multiSelect.deselectAll'|translate }}
      </button>

      <button
        *ngPermissions="permissionService.Permission.location_export"
        actions
        type="button"
        sb-button-primary
        [color]="'blue'"
        icon="download"
        (click)="showSideBar= true; isSelectedLocationsExport = true;"
        [disabled]="loading()|| showSideBar">
        {{ 'lang.globals.exportSelected'|translate }}
      </button>
    </sb-action-bar>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-location>
    <tr>
      @if (!selectionMode) {

        <td class="sticky-col first-col">
          @let isItemSelected = selectedLocations().has(location?.id) ?? false;
          <sb-comp-table-select-button [isSelected]="isItemSelected" (action)="selectLocation(location)"></sb-comp-table-select-button>
        </td>
      }
      <td [location]="location" class="sw" sb-comp-location-online-status>
      </td>
      <td>
        <sb-icon class="mr-2" icon="screen"></sb-icon>
        {{ location?.countDevices }}
      </td>
      <td *ngPermissions="[permissionService.Permission.tag_list]">
        <sb-tags [dtoId]="location?.id" [dtoType]="tagService.TaggableDTO.Location" [tags]="location.tags"></sb-tags>
      </td>
      @for (col of selectedColumns; track col.id) {
        @let column = createTableCell(col, 'Location', location);
        <td>
          <sb-comp-dynamic-table-element [displayColumn]="column" [isInIntegratedContext]="selectionMode"></sb-comp-dynamic-table-element>
        </td>
      }
      <td class="sticky-col last-col tr">
        <div>
          <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: location}"></ng-container>
        </div>
      </td>
    </tr>
  </ng-template>

  <div *ngIf="isInModalContext" footer-more>
    <div class="row">
      <div class="col-8">
        <div class="row" style="height: 100%; display: flex; align-items: center;">
          <div *ngFor="let e of selectedLocations() | keyvalue" class="col-3">
            <a [innerHTML]="e.value.name | truncate : 25" class="font-weight-bold link mr-2"
               style="white-space: nowrap; height: 30px;"></a>
          </div>
        </div>
      </div>
      <div class="col-4 justify-content-end d-flex align-items-center">
            <span
              class="mr-2 font-weight-bold text-dark">{{ selectedLocations()?.size }} {{ 'lang.globals.productsSelected' | translate }}</span>
        <button (click)="deselectLocations()" [disabled]="selectedLocations()?.size < 1"
                class="btn btn-danger btn-sm mr-1">{{ 'lang.globals.deselectAll' | translate }}
        </button>
        <button (click)="returnSelectedLocation()"
                class="btn btn-primary btn-sm">{{ 'lang.globals.save' | translate }}
        </button>
      </div>
    </div>
  </div>
  <!------------------------------

Card Element

------------------------------->

  <ng-template #card let-location>
    <sb-table-card [isHalfImgHeight]="true"
                   [classes]="'hover:tw-bg-sbGrayBlue-100 '">
      <div table-card-header>
        @let isCampaignSelected = selectedLocations().has(location?.id) ?? false;
        <sb-comp-table-select-button [isSelected]="isCampaignSelected" (action)="selectLocation(location)"></sb-comp-table-select-button>
      </div>

      <div table-card-header-more>
        <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: location}"></ng-container>
      </div>
      <div table-card-img>
        <div class="tw-bg-[url(assets/img/location-placeholder-bg.jpg)] tw-bg-cover tw-bg-center tw-h-full">
        </div>

      </div>
      <div table-card-body>
        <div
          class="sm:tw-grid sm:tw-grid-cols-4 tw-flex tw-flex-col tw-text-sbGray-800 *:sm:tw-col-span-2 *:tw-w-full *:tw-border-0 *:tw-border-b *:tw-border-solid *:tw-border-sbGray-200 *:sm:tw-py-5 *:tw-py-3.5">

          <sb-table-card-element [headline]="'Status'" [orientation]="'left'">
            <div [location]="location" sb-comp-location-online-status></div>
          </sb-table-card-element>
          <sb-table-card-element [classes]="'tw-gap-2'" [headline]="'lang.globals.devices' | translate" [orientation]="'right'">
            <sb-icon icon="playerOnline"></sb-icon>
            <div>{{ location?.countDevices }}</div>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-col-span-4" [headline]="'Tags'" [orientation]="'left'">
            <sb-tags [dtoId]="location.id" [dtoType]="tagService.TaggableDTO.Location"
                     [tags]="location.tags"></sb-tags>
          </sb-table-card-element>
          @for (col of selectedColumns; track col.id; let odd = $odd; let last = $last; let index = $index; let count = $count) {
            @let column = createTableCell(col, 'Location', location);
            @let isEvenColumns = (selectedColumns?.length % 2) === 0;
            <sb-table-card-element
              [headline]="column.title ?? column.id | translate"
              [ngClass]="{'!tw-border-0': last || (isEvenColumns && ((selectedColumns?.length - 2) === index)) }"
              [orientation]="odd ? 'right' : 'left'">
              <sb-comp-dynamic-table-element [displayColumn]="column"
                                             [isInIntegratedContext]="selectionMode"></sb-comp-dynamic-table-element>
            </sb-table-card-element>
          }
        </div>
      </div>
    </sb-table-card>
  </ng-template>
</sb-table-wrapper-new>

<ng-template #ActionButtons let-location>
  @if (selectionMode) {
    <button
      *ngPermissions="permissionService.Permission.attachment_attach_to_location"
      type="button"
      sb-button-secondary
      [color]="'blue'"
      [iconButton]="true"
      (click)="elementSelected.emit(location)"
      [sbTooltip]="'lang.globals.linkAttachment' | translate"
      icon="link">
    </button>
  } @else {
    @if (isInModalContext) {
      @let isDeviceSelected = selectedLocations().has(location?.id) ?? false;
      <button
        type="button"
        sb-button-secondary
        [color]="'blue'"
        class="tw-px-2"
        (click)="selectLocation(location)"
      >
        @if (isDeviceSelected) {
          <sb-icon [icon]="'boxChecked'"></sb-icon>
        } @else {
          <sb-icon [icon]="'box'"></sb-icon>
        }
      </button>
    } @else {
      <sb-split-button
        [splitButtonItems]="location?.sbButtons ?? []"
        (selectedAction)="resolveSplitButtonAction(location, $event)"
      ></sb-split-button>
    }
  }

</ng-template>
